import PropTypes from 'prop-types';
import Modal from '../components/layout/modal.jsx';

import React from 'react';

import authApi from '../../api/auth.jsx';

import articleApi from '../../api/article.jsx';

import {userLevels} from '../helpers/constants.jsx';

import Markdown from 'react-remarkable';

import Loader from '../components/loader.jsx';

class IntroVideo extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
  };

  state = {
    article: null,
  };

  componentWillMount() {
    let articleName = 'introduction-to-alex';

    if (this.props.user.privileges.level >= userLevels.dealerAdmin) {
      articleName = 'introduction-to-alex-dealer';
    } else if (this.props.user.privileges.level >= userLevels.manager) {
      articleName = 'introduction-to-alex-store';
    }
    articleApi.getArticle(articleName).then(article => {
      this.setState({article});
    });
  }

  watchIntroVideo = () => {
    authApi.watchIntroVideo()
      .then(() => {
        window.location.hash = 'customers?tour';
        window.location.reload(false);
      });
  };

  render() {
    let userType = 'Water Testers';

    if (this.props.user.privileges.level >= userLevels.manager) {
      userType = 'Store Managers';
    }
    if (this.props.user.privileges.level >= userLevels.dealerAdmin) {
      userType = 'Dealer Managers';
    }

    return (
      <div className='intro-video'>
        <Modal onClose={this.watchIntroVideo}>
          <Loader loaded={!!this.state.article}>
            <h1>Hi {this.props.user.name}, Welcome to ALEX<sup>&reg;</sup> Pro!</h1>
            <Markdown options={{html: true}}>
              {this.state.article && this.state.article.body}
            </Markdown>
            <div className='intro-video-footer'>
              <button type='button'
                className='btn btn-primary pull-right'
                onClick={this.watchIntroVideo}>
                Get Started
              </button>
              <h4>Introduction to ALEX<sup>&reg;</sup> Pro for {userType}</h4>
            </div>
          </Loader>
        </Modal>
      </div>
    );
  }
}

export default IntroVideo;
